import {
  IconBrandInstagram,
  IconBrandTelegram,
  IconBrandWhatsapp,
  IconMail,
  IconPhone,
  IconBrandTwitter,
} from "@tabler/icons-react";
import {
  ActionIcon,
  Anchor,
  Container,
  Group,
  Text,
  Title,
  SimpleGrid,
  Stack,
  ThemeIcon,
  rem,
  Divider,
} from "@mantine/core";
import { Link } from "react-router-dom";

import {
  LogoFull,
  SocialLinks,
  ContactInformation,
  Colors,
} from "../../../Lib/Data";

import "./styles.scss";

const links = [
  { link: "/d/services", label: "Services" },
  { link: "/sign-up", label: "Get Started" },
  { link: "/terms", label: "Terms of Service" },
  { link: "/privacy", label: "Privacy Policy" },
  { link: "#contact", label: "Contact Support", id: true },
];

const socials = [
  { icon: IconBrandInstagram, link: SocialLinks.instagramLink },
  { icon: IconBrandTelegram, link: SocialLinks.telegramLink },
  { icon: IconBrandWhatsapp, link: SocialLinks.whatsappLink },
];

export default function HomeFooter() {
  const currentYear = new Date().getFullYear();

  const items = links.map((link) => {
    if (link.id) {
      return (
        <a
          href={link.link}
          key={link.label}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Text className="footer-link" size="sm" c="dimmed">
            {link.label}
          </Text>
        </a>
      );
    }
    return (
      <Link
        to={link.link}
        key={link.label}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <Text className="footer-link" size="sm" c="dimmed">
          {link.label}
        </Text>
      </Link>
    );
  });

  return (
    <div
      className="footer-container"
      style={{
        borderTop: "1px solid var(--mantine-color-gray-2)",
        marginTop: 80,
        paddingTop: 60,
        paddingBottom: 20,
      }}
    >
      <Container size="lg">
        <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing={50} mb={50}>
          {/* Column 1: Brand */}
          <Stack gap="lg">
            <img
              src={LogoFull}
              alt="Manysubs"
              style={{
                height: 40,
                width: "auto",
                objectFit: "contain",
                objectPosition: "left",
              }}
            />
            <Text c="dimmed" size="sm" lh={1.6}>
              Premium subscriptions at a fraction of the price. Join thousands
              of users saving money on their favorite services today.
            </Text>
          </Stack>

          {/* Column 2: Quick Links */}
          <Stack gap="lg">
            <Text fw={700} size="lg" c={Colors.GreenSecondary}>
              Quick Links
            </Text>
            <Stack gap={10}>{items}</Stack>
          </Stack>

          {/* Column 3: Contact */}
          <Stack gap="lg">
            <Text fw={700} size="lg" c={Colors.GreenSecondary}>
              Contact Us
            </Text>
            <Stack gap="md">
              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size="md" variant="light" color="green">
                  <IconMail style={{ width: rem(18), height: rem(18) }} />
                </ThemeIcon>
                <div style={{ flex: 1 }}>
                  <Text
                    size="sm"
                    component="a"
                    href={`mailto:${ContactInformation.email}`}
                    c="dark"
                    style={{ textDecoration: "none" }}
                  >
                    {ContactInformation.email}
                  </Text>
                </div>
              </Group>

              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size="md" variant="light" color="green">
                  <IconPhone style={{ width: rem(18), height: rem(18) }} />
                </ThemeIcon>
                <div style={{ flex: 1 }}>
                  <Text
                    size="sm"
                    component="a"
                    href={SocialLinks.whatsappLink}
                    target="_blank"
                    c="dark"
                    style={{ textDecoration: "none" }}
                  >
                    {ContactInformation.phone}
                  </Text>
                </div>
              </Group>
            </Stack>
          </Stack>

          {/* Column 4: Socials */}
          <Stack gap="lg">
            <Text fw={700} size="lg" c={Colors.GreenSecondary}>
              Follow Us
            </Text>
            <Group gap="sm">
              {socials.map((social, index) => (
                <ActionIcon
                  key={index}
                  size="xl"
                  radius="xl"
                  variant="subtle"
                  color="green"
                  component="a"
                  href={social.link}
                  target="_blank"
                >
                  <social.icon
                    style={{ width: rem(24), height: rem(24) }}
                    stroke={1.5}
                  />
                </ActionIcon>
              ))}
            </Group>
          </Stack>
        </SimpleGrid>

        <Divider my="xl" />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Text c="dimmed" size="sm">
            © {currentYear} Manysubs. All rights reserved.
          </Text>

          <Text c="dimmed" size="xs">
            Manysubsng is a product of{" "}
            <Anchor
              href="https://theajstars.co"
              target="_blank"
              c="dimmed"
              fw={500}
            >
              Theajstars
            </Anchor>
            {" & "}
            <Anchor
              href="https://iniisking.com"
              target="_blank"
              c="dimmed"
              fw={500}
            >
              Iniisking
            </Anchor>
          </Text>
        </div>
      </Container>

      <style>{`
        .footer-link:hover {
          color: ${Colors.GreenSecondary};
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}
